import { FC, useEffect, useState } from "react";
import { useProject } from "../../../providers/ProjectProvider";
import { LabelingProject, LabelRequest } from "../../../data/Project";
import { Link, useParams } from "react-router-dom";
import moment from 'moment';
import { Clock, ClockAfternoon, IdentificationBadge, Images, Users } from "@phosphor-icons/react";
import { Timestamp } from "firebase/firestore";
import { PencilRuler } from "@phosphor-icons/react/dist/ssr";

export type ProjectDetailPageProps = {}

export const ProjectDetailPage: FC<ProjectDetailPageProps> = () => {
    const params = useParams();
    
    const projectId = params['projectId']!;
    const { getLabelingProject } = useProject();
    const [project, setProject] = useState<LabelingProject | null>(null);
    
    const formatFromNow = (date: Timestamp) => {
        return moment(date.toDate()).fromNow();
    }

    useEffect(() => {
        getLabelingProject(projectId)
            .then(project => {
                setProject(project);
            });
    }, [projectId, getLabelingProject, setProject]);

    if (!project) {
        return <div>Loading...</div>;
    }

    return (
        <div className="min-h-screen bg-gray-100 p-4">
        <h1 className="text-3xl font-bold mb-4">{project.name}</h1>
        <div className="flex flex-row items-center space-x-4 my-4">
            <div className="flex flex-row items-center px-4 py-2 bg-white shadow-lg rounded-lg">
                <IdentificationBadge className="text-indigo-600" size={24} weight="duotone"/>
                <span className="text-gray-600 font-mono text-sm ml-2">{project.identifier}</span>
            </div>

            <div className="flex flex-row items-center px-4 py-2 bg-white shadow-lg rounded-lg">
                <Images className="text-indigo-600" size={24} weight="duotone"/>
                <span className="text-gray-600 font-mono text-sm ml-2">{project.images.length} images</span>
            </div>

            <div className="flex flex-row items-center px-4 py-2 bg-white shadow-lg rounded-lg">
                <Users className="text-indigo-600" size={24} weight="duotone"/>
                <span className="text-gray-600 font-mono text-sm ml-2">{project.allowedUsers.length} labelers</span>
            </div>

            <div className="flex flex-row items-center px-4 py-2 bg-white shadow-lg rounded-lg">
                <ClockAfternoon className="text-indigo-600" size={24} weight="duotone"/>
                <span className="text-gray-600 font-mono text-sm ml-2">Last updated {formatFromNow(project.lastUpdatedAt)}</span>
            </div>

            <div className="flex flex-row items-center px-4 py-2 bg-white shadow-lg rounded-lg">
                <Clock className="text-indigo-600" size={24} weight="duotone"/>
                <span className="text-gray-600 font-mono text-sm ml-2">Created {formatFromNow(project.createdAt)}</span>
            </div>
        </div>
            <div className="overflow-x-auto">
                <table className="min-w-full bg-white shadow-lg rounded-lg">
                    <thead>
                        <tr>
                            <th className="px-6 py-3 border-b-2 border-gray-300 text-left leading-4 text-gray-600 tracking-wider">Image ID</th>
                            <th className="px-6 py-3 border-b-2 border-gray-300 text-left leading-4 text-gray-600 tracking-wider">Task</th>
                            <th className="px-6 py-3 border-b-2 border-gray-300 text-left leading-4 text-gray-600 tracking-wider">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {project.labelRequests.map((labelRequest: LabelRequest) => (
                            <tr key={`${labelRequest.imageId}-${labelRequest.task}`} className="hover:bg-gray-100 transition-colors duration-300">
                                <td className="px-6 py-4 border-b border-gray-300 font-mono">{labelRequest.imageId}</td>
                                <td className="px-6 py-4 border-b border-gray-300">{labelRequest.task}</td>
                                <td className="px-6 py-4 border-b border-gray-300">
                                    <Link to={`/editor/${project.id}/${labelRequest.task}/${labelRequest.imageId}`}>
                                            <button className="flex items-center space-x-2 text-indigo-500 hover:text-indigo-700">
                                                <PencilRuler size={24} />
                                                <span>Label</span>
                                            </button>
                                    </Link>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}